import { OperateurInformationsDomaine } from './operateur-informations-domaine.model';
import { ArrayClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class OperateursInformationsDomaine {
    static jsonMap = {
        idOperateur: { key: 'idOperateur' },
        domaines: { key: 'domaines', converter: new (ArrayClassConverterFactory.build(OperateurInformationsDomaine))(), default: () => [] }
    };

    idOperateur: number;
    domaines: OperateurInformationsDomaine[];
}
